var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7368 15.1579V9.26315M9 15.1579V6.73684M2.26316 15.1579L2.26316 11.7895M10.1846 2.54947L14.5369 4.18161M7.98844 2.86393L3.27388 6.39985M16.63 3.73839C17.1233 4.23168 17.1233 5.03147 16.63 5.52476C16.1367 6.01806 15.3369 6.01806 14.8437 5.52476C14.3504 5.03147 14.3504 4.23168 14.8437 3.73839C15.3369 3.24509 16.1367 3.24509 16.63 3.73839ZM3.15635 6.2647C3.64964 6.758 3.64964 7.55779 3.15635 8.05108C2.66305 8.54437 1.86326 8.54437 1.36997 8.05108C0.876677 7.55779 0.876677 6.758 1.36997 6.2647C1.86326 5.77141 2.66305 5.77141 3.15635 6.2647ZM9.89319 1.21207C10.3865 1.70537 10.3865 2.50515 9.89319 2.99845C9.39989 3.49174 8.60011 3.49174 8.10681 2.99845C7.61352 2.50515 7.61352 1.70537 8.10681 1.21207C8.60011 0.718779 9.39989 0.718779 9.89319 1.21207Z",
    stroke: "#118F84",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestment);
export default __webpack_public_path__ + "static/media/INVESTMENT.1c1eac71fb3b9968f0230018826d52b4.svg";
export { ForwardRef as ReactComponent };